import React from "react";
import getString from "../../../config/strings";
import Button from "../Button";
import Input from "../Input";
import { SubscriberContainer,MarginBlock } from "./styles";
import firebase from "firebase/app";
import "firebase/database";
import ReactGA from "react-ga";
var firebaseConfig = {
  apiKey: "AIzaSyBkTLMJfCoaqsqHn1EXDK0rvXhJgcn8SWw",
  authDomain: "email-capture-market-sentiment.firebaseapp.com",
  projectId: "email-capture-market-sentiment",
  storageBucket: "email-capture-market-sentiment.appspot.com",
  messagingSenderId: "997056792167",
  appId: "1:997056792167:web:760917e229debfaf68f6c2",
  measurementId: "G-XJ2J7VZQVN"
};

firebase.initializeApp(firebaseConfig);

var messagesRef = firebase.database().ref('messages');


function Subscriber() {
  const [email,setEmail ] = React.useState("");
  function subscribe(){
    var today = new Date();
      var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      var newMessageRef = messagesRef.push();
      newMessageRef.set(
          {
              email: email,
              date: date 
          }
      );
      setEmail("");
      ReactGA.event({
        category: 'Home',
        action: 'User Subscribed',
        label:email,
      });
      alert("You're now subscribed to our newsletter");

  }
  return (
    <SubscriberContainer>
      <Input width="300px" type="email" value={email} setValue={setEmail}/>
      <MarginBlock/>
      <Button text={getString("Subscribe")} onClick={subscribe}/>
    </SubscriberContainer>
  );
}
export default Subscriber;
